export const COOKIE_KEYS = {
  auth: {
    accessToken: 'access_token',
  },
  referral: {
    code: 'referral_code',
  },
  utm: {
    source: 'utm_source',
    campaign: 'utm_campaign',
  },
  redirectTo: 'redirect-to',
  fundraiser: {
    access_token: 'f_access_token',
    redirectTo: 'f_redirect-to',
  },
}
